import React, { useEffect, useRef } from "react";
import "../assets/css/SortFilterDropdown.css";

const SortFilterDropdown = ({ columnId, onSort, onClose, currentSortOrder }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  // Custom labels based on column
  // const getLabel = (order) => {
  //   if (columnId === "last_credit_payment_date") {
  //     return order === "asc" ? "↑ Ascending" : "↓ Descending";
  //   }
  //   // default for name column or others
  //   return order === "asc" ? "↑ Sort A to Z" : "↓ Sort Z to A";
  // };

  const getLabel = (order) => {
    if (columnId === "name") {
      return order === "asc" ? "↑ Sort A to Z" : "↓ Sort Z to A";
    }
    if (columnId === "status") {
      return order === "asc" ? "↑ Present" : "↓ Absent";
    }
    if (columnId === "clockIn") {
      return order === "asc" ? "↑ Earliest Punch In" : "↓ Latest Punch In";
    }

    if (columnId === "last_credit_payment_date") {
      return order === "asc" ? "↑ Ascending" : "↓ Descending";
    }
    if (columnId === "student_name") {
      return order === "asc" ? "↑ Sort A to Z" : "↓ Sort Z to A";
    }
    if (columnId === "balance") {
      return order === "asc" ? "↑ Ascending" : "↓ Descending";
    }
   if (columnId === "previous_institution") {
      return order === "asc" ? "↑ Sort A to Z" : "↓ Sort Z to A";
    }
    if (columnId === "noc_status") {
      return order === "asc"
        ? "↑ Pending"
        : "↓ Completed";
    }

    // if (columnId === "all_precheck_names") {
    //   return order === "asc" ? "↑ No Dues Clearance (✔)" : "↓ No Dues Clearance (✘)";
    // }
    return order === "asc" ? "↑ Ascending" : "↓ Descending";
  };

  const shiftColumns = ["balance", "all_precheck_names"];


  return (
    <div
      ref={dropdownRef}
      className={`sort-dropdown-menu 
    ${columnId === "balance" ? "sort-dropdown--shift-left" : ""}
    ${columnId === "all_precheck_names" ? "sort-dropdown--precheck" : ""}
    ${columnId === "noc_status" ? "sort-dropdown--noc-status" : ""}`} // ✅ extra class
    >



      <button
        className="dropdown-item"
        onClick={() => {
          onSort(columnId, "asc");
          onClose?.();
        }}
      >
        {getLabel("asc")}
      </button>
      <button
        className="dropdown-item"
        onClick={() => {
          onSort(columnId, "desc");
          onClose?.();
        }}
      >
        {getLabel("desc")}
      </button>
    </div>
  );
};

export default SortFilterDropdown;
